import React, { useEffect, useRef, useState } from "react";
import { Button, CircularProgress, Dialog, DialogContent, DialogTitle } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

const PdfViewerDialog = ({ blob, onClose }) => {
  const containerRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!blob) return undefined;
    let cancelled = false;
    let pdf = null;

    const render = async () => {
      setLoading(true);
      setError(false);
      try {
        const pdfjs = await import('pdfjs-dist/legacy/build/pdf');
        const worker = await import('pdfjs-dist/legacy/build/pdf.worker.entry');
        pdfjs.GlobalWorkerOptions.workerSrc = worker.default || worker;

        const data = new Uint8Array(await new Response(blob).arrayBuffer());
        pdf = await pdfjs.getDocument({ data }).promise;
        const container = containerRef.current;
        if (cancelled || !container) return;
        container.innerHTML = '';

        for (let pageNumber = 1; pageNumber <= pdf.numPages; pageNumber += 1) {
          const page = await pdf.getPage(pageNumber);
          if (cancelled) return;
          const baseViewport = page.getViewport({ scale: 1 });
          const cssScale = (container.clientWidth || baseViewport.width) / baseViewport.width;
          const pixelRatio = window.devicePixelRatio || 1;
          const viewport = page.getViewport({ scale: cssScale * pixelRatio });

          const canvas = document.createElement('canvas');
          canvas.width = viewport.width;
          canvas.height = viewport.height;
          canvas.style.width = '100%';
          canvas.style.maxWidth = '100%';
          canvas.style.height = 'auto';
          canvas.style.display = 'block';
          canvas.style.marginBottom = '8px';
          container.appendChild(canvas);
          await page.render({ canvasContext: canvas.getContext('2d'), viewport }).promise;
        }
      } catch (e) {
        if (!cancelled) setError(true);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    render();
    return () => {
      cancelled = true;
      if (pdf) pdf.destroy();
    };
  }, [blob]);

  return (
    <Dialog
      open={!!blob}
      onClose={onClose}
      fullScreen
      PaperProps={{ style: { width: '100%', maxWidth: '100vw', overflowX: 'hidden' } }}
    >
      <DialogTitle disableTypography style={{ display: 'flex', justifyContent: 'flex-end', padding: '8px' }}>
        <Button color="primary" startIcon={<CloseIcon />} onClick={onClose}>
          Cerrar
        </Button>
      </DialogTitle>
      <DialogContent style={{ padding: 0, overflowX: 'hidden' }}>
        {loading && (
          <div style={{ textAlign: 'center', padding: 16 }}>
            <CircularProgress size={28} />
          </div>
        )}
        {error && <div style={{ padding: 16 }}>No se pudo mostrar el PDF</div>}
        <div ref={containerRef} style={{ width: '100%' }} />
      </DialogContent>
    </Dialog>
  );
};

export default PdfViewerDialog;
